var exports = {
  "dL": "GuildHeader.module__headerWrapper___Zm1QbE",
  "N1": "GuildHeader.module__headerContainer___Zm1QbE",
  "bp": "GuildHeader.module__headerContainerActive___Zm1QbE",
  "vf": "GuildHeader.module__headerContainerBanner___Zm1QbE",
  "Le": "GuildHeader.module__headerContainerCollapsing___Zm1QbE",
  "On": "GuildHeader.module__headerContainerNoBanner___Zm1QbE",
  "nL": "GuildHeader.module__bannerClip___Zm1QbE",
  "_e": "GuildHeader.module__bannerImage___Zm1QbE",
  "Oo": "GuildHeader.module__bannerImageCentered___Zm1QbE",
  "iI": "GuildHeader.module__headerGlass___Zm1QbE",
  "nY": "GuildHeader.module__bannerGradient___Zm1QbE",
  "VW": "GuildHeader.module__headerContent___Zm1QbE",
  "KZ": "GuildHeader.module__headerFocusRing___Zm1QbE",
  "w$": "GuildHeader.module__verifiedIcon___Zm1QbE",
  "Ve": "GuildHeader.module__verifiedIconDefault___Zm1QbE" + " " + "GuildHeader.module__verifiedIcon___Zm1QbE",
  "J5": "GuildHeader.module__guildName___Zm1QbE",
  "K8": "GuildHeader.module__guildNameDefault___Zm1QbE" + " " + "GuildHeader.module__guildName___Zm1QbE",
  "rr": "GuildHeader.module__guildNameWithBanner___Zm1QbE" + " " + "GuildHeader.module__guildName___Zm1QbE",
  "Rq": "GuildHeader.module__caretIcon___Zm1QbE",
  "Ic": "GuildHeader.module__caretIconDefault___Zm1QbE" + " " + "GuildHeader.module__caretIcon___Zm1QbE",
  "Tu": "GuildHeader.module__caretIconWithBanner___Zm1QbE" + " " + "GuildHeader.module__caretIcon___Zm1QbE",
  "xu": "GuildHeader.module__caretIconOpen___Zm1QbE",
  "_S": "GuildHeader.module__dotsIcon___Zm1QbE",
  "D1": "GuildHeader.module__dotsIconDefault___Zm1QbE" + " " + "GuildHeader.module__dotsIcon___Zm1QbE",
  "GX": "GuildHeader.module__dotsIconWithBanner___Zm1QbE" + " " + "GuildHeader.module__dotsIcon___Zm1QbE",
};

module.exports = exports;
